import '../css/Name-Anim.css';

const Name = () => {
    return (
        <div className='name-anim-div'>
        <h1 className="large-screen line-1 anim-typewriter-1">Arundhati</h1>
        <h1 className="large-screen line-2 anim-typewriter-2 delay">Bandopadhyaya.</h1>
        <p className="small-screen line-1 anim-typewriter-1">Arundhati</p>
        <p className="small-screen line-2 anim-typewriter-2 delay">Bandopadhyaya.</p>
        </div>
    );
}

export default Name;